<template>
  <div>
    <add-cash-in-method
      :country_id="country_id"
      :is-active.sync="isAdding"
      @added="cashInMethodAdded"
    />
    <data-table
      title="CashIn Methods"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add CashIn Method
        </v-btn>
      </template>
      <template slot="item.actions" slot-scope="{ item }">
        <v-icon medium title="Delete CashIn Method" @click.stop="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddCashInMethod from "./new";

export default {
  props: { country_id: { required: true, type: [Number, String] } },
  components: { AddCashInMethod },
  data() {
    return {
      isAdding: false,
      showArchived: false,
      headers: {
        "cash_in_method.name": "Name",
        "cash_in_method.payment_type.name": "Type",
        "cash_in_method.payment_provider.name": "Provider",
        "cash_in_method.min_amount": "Min Amount",
        "cash_in_method.max_amount": "Max Amount",
        actions: "Actions",
      },
      fields: {
        min_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        max_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
    };
  },
  computed: {
    url() {
      return `api/v1/transactions/cryptoCountry/${this.country_id}/cashInMethods`;
    },
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    cashInMethodAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    showDetails(cashInMethod) {
      const { cash_in_method } = cashInMethod;
      this.$router.push({ name: "crypto.cashInMethods.show", params: { id: cash_in_method.id } });
    },
    deleteItem(item) {
      Notify.confirm(`The cashIn method will be removed.`).then(() => {
        this.$http
          .delete(`/api/v1/transactions/cryptoCountry/${this.country_id}/cashInMethods/${item.id}`)
          .then(() => {
            Notify.success("CashIn method was successfully deleted.");
            // refresh the table data
            this.$refs.table.fetchData();
          });
      });
    },
  },
};
</script>
